import * as n from "react";
import { p as l } from "./index-efd35e77.js";
import { v as te, p as re, c as H } from "./package-metadata-9ad1330d.js";
import { u as le, k as X, I as j, t as V, s as G } from "./theme-b013fa81.js";
import { K as z } from "./keys-2b65407d.js";
var xe = -1, Ie = 0, ie = function(e, a, r) {
  var t = typeof e == "string" ? parseInt(e, void 0) : e;
  if (t !== NaN)
    return t !== void 0 ? t : a ? r ? void 0 : xe : Ie;
}, Ee = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
function _e(e) {
  var a = [];
  return e.replace(Ee, function(r, t, i, c) {
    a.push(t !== void 0 ? t : i || c);
  }), a;
}
var w = {};
w.undefined = function() {
};
function ne(e) {
  if (w[e])
    return w[e];
  var a = _e(e);
  return w[e] = function(r) {
    for (var t = r, i = 0; i < a.length && t; i++)
      t = t[a[i]];
    return t;
  }, w[e];
}
function ue(e, a, r) {
  var t = n.useState(a), i = t[0], c = t[1];
  return n.useEffect(function() {
    if (!i && window && e.current) {
      var o = window.getComputedStyle(e.current).direction;
      o && c(o);
    }
  }, r), i;
}
var L = globalThis && globalThis.__spreadArray || function(e, a, r) {
  if (r || arguments.length === 2)
    for (var t = 0, i = a.length, c; t < i; t++)
      (c || !(t in a)) && (c || (c = Array.prototype.slice.call(a, 0, t)), c[t] = a[t]);
  return e.concat(c || Array.prototype.slice.call(a));
}, F;
(function(e) {
  e.single = "single", e.multiple = "multiple", e.none = "none";
})(F || (F = {}));
var y;
(function(e) {
  e.toggle = "toggle", e.remove = "remove";
})(y || (y = {}));
var we = function(e, a) {
  switch (a.selection) {
    case F.single:
      switch (a.type) {
        case y.toggle: {
          if (!Array.isArray(e) || e === null)
            return a.payload === e ? null : a.payload;
          throw new Error("State cannot be an array in single selection");
        }
        case y.remove:
          return a.payload === e ? null : e;
        default:
          return e;
      }
    case F.multiple:
      switch (a.type) {
        case y.toggle: {
          if (Array.isArray(e))
            return e.some(function(r) {
              return r === a.payload;
            }) ? e.filter(function(r) {
              return r !== a.payload;
            }) : L(L([], e, !0), [a.payload], !1);
          if (e === null)
            return [a.payload];
          throw new Error("State cannot be non-array in multiple selection");
        }
        case y.remove:
          return Array.isArray(e) ? e.some(function(r) {
            return r === a.payload;
          }) ? e.filter(function(r) {
            return r !== a.payload;
          }) : L(L([], e, !0), [a.payload], !1) : e;
        default:
          return e;
      }
    case F.none:
      return null;
    default:
      return e;
  }
}, m;
(function(e) {
  e.next = "next", e.prev = "prev", e.current = "current", e.reset = "reset";
})(m || (m = {}));
var Fe = function(e, a) {
  var r = a.items.findIndex(function(t) {
    return t === e;
  });
  switch (a.type) {
    case m.next:
      return r === a.items.length - 1 ? e : a.items[r + 1];
    case m.prev:
      return r === 0 ? e : a.items[r - 1];
    case m.current:
      return a.payload;
    case m.reset:
      return null;
    default:
      return e;
  }
}, x;
(function(e) {
  e.remove = "remove", e.add = "add", e.reorder = "reorder";
})(x || (x = {}));
var Se = function(e, a) {
  switch (a.type) {
    case x.add:
      break;
    case x.remove:
      return e.filter(function(r) {
        return r[a.valueField] !== a.payload;
      });
    case x.reorder:
      break;
    default:
      return e;
  }
}, h = globalThis && globalThis.__assign || function() {
  return h = Object.assign || function(e) {
    for (var a, r = 1, t = arguments.length; r < t; r++) {
      a = arguments[r];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i]);
    }
    return e;
  }, h.apply(this, arguments);
}, ce = n.createContext([null, function(e) {
}]), de = n.createContext([null, function(e) {
}]), oe = n.createContext([null, function(e) {
}]), Re = function(e, a, r) {
  var t = n.useState(e), i = t[0], c = t[1], o = function(v) {
    var s = we(a.state || i, h(h({}, v), a));
    r && r(s, v.event), c(s);
  };
  return [i, o];
}, Me = function(e) {
  var a = n.useState(null), r = a[0], t = a[1], i = function(c) {
    var o = Fe(c.payload, h(h({}, c), e));
    t(o);
  };
  return [r, i];
}, Ne = function(e, a, r) {
  var t = n.useState(e), i = t[0], c = t[1], o = function(v) {
    var s = Se(a.state || i, h(h({}, v), a));
    r && r(s, v.event), c(s);
  };
  return [i, o];
}, W = n.forwardRef(function(e, a) {
  var r;
  te(re);
  var t = n.useRef(null), i = n.useRef(null), c = ue(i, e.dir), o = e.chip, v = e.id, s = e.style, S = e.tabIndex, E = e.disabled, f = e.size, T = e.className, R = e.ariaDescribedBy, _ = e.ariaLabelledBy, b = e.selection, O = b === void 0 ? D.selection : b, k = e.value, C = k === void 0 ? D.defaultValue : k, M = e.defaultData, A = M === void 0 ? D.defaultData : M, N = e.valueField, u = N === void 0 ? D.valueField : N, q = e.textField, J = q === void 0 ? D.textField : q, P = e.onChange, K = e.onDataChange, se = n.useMemo(function() {
    return o || I;
  }, [o, I]);
  n.useImperativeHandle(t, function() {
    return {
      element: i.current,
      props: e
    };
  }), n.useImperativeHandle(a, function() {
    return t.current;
  });
  var ve = n.useCallback(function(d, g) {
    P && t.current && P.call(void 0, {
      value: d,
      target: t.current,
      syntheticEvent: g
    });
  }, [P]), Q = Re(C, {
    selection: O,
    state: C
  }, ve), Z = Q[0], fe = Q[1], me = n.useCallback(function(d, g) {
    K && t.current && K.call(void 0, {
      value: d,
      target: t.current,
      syntheticEvent: g
    });
  }, [K]), U = Ne(e.data || A, {
    state: e.data,
    valueField: u
  }, me), Y = U[0], ye = U[1], p = n.useCallback(function(d, g) {
    return d.push(g[u]), d;
  }, [u]), B = n.useMemo(function() {
    return e.data || Y;
  }, [e.data, Y]), he = n.useMemo(function() {
    return C || Z;
  }, [C, Z]), ge = n.useMemo(function() {
    return B.reduce(p, []);
  }, [B, p]), ee = n.useCallback(function(d) {
    return ne(u)(d);
  }, [u]), be = n.useCallback(function(d) {
    return ne(J)(d);
  }, [J]), ae = Me({ items: ge }), ke = ae[0], Ce = ae[1], De = le(e, t);
  return n.createElement(
    ce.Provider,
    { value: [he, fe] },
    n.createElement(
      de.Provider,
      { value: [ke, Ce] },
      n.createElement(
        oe.Provider,
        { value: [B, ye] },
        n.createElement("div", h({ ref: i }, De, { role: "listbox", id: v, dir: c, style: s, tabIndex: ie(S, E, void 0), className: H("k-chip-list", (r = {
          "k-rtl": c === "rtl",
          "k-disabled": E
        }, r["k-chip-list-".concat(X.sizeMap[f] || f)] = f, r), T), "aria-labelledby": _, "aria-describedby": R }), B.map(function(d, g) {
          return n.createElement(se, { role: "option", dataItem: d, size: f, key: [ee(d), g].join("-"), text: be(d), value: ee(d), ariaLabel: d.ariaLabel });
        }))
      )
    )
  );
}), Be = {
  id: l.string,
  className: l.string,
  tabIndex: l.number,
  data: l.any,
  defaultData: l.arrayOf(l.any),
  onDataChange: l.func,
  value: l.oneOfType([l.any, l.arrayOf(l.any)]),
  defaultValue: l.oneOfType([l.any, l.arrayOf(l.any)]),
  onChange: l.func,
  selection: l.oneOf(["single", "none", "multiple"]),
  textField: l.string,
  valueField: l.string,
  disabled: l.bool,
  dir: l.oneOf(["ltr", "rtl"]),
  ariaLabelledBy: l.string,
  ariaDescribedBy: l.string,
  size: l.oneOf([null, "small", "medium", "large"])
}, D = {
  chip: I,
  size: "medium",
  disabled: !1,
  defaultValue: null,
  defaultData: [],
  dir: "ltr",
  selection: "none",
  textField: "text",
  valueField: "value",
  removable: "removable"
};
W.displayName = "KendoReactChipList";
W.propTypes = Be;
W.defaultProps = D;
var $ = globalThis && globalThis.__assign || function() {
  return $ = Object.assign || function(e) {
    for (var a, r = 1, t = arguments.length; r < t; r++) {
      a = arguments[r];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i]);
    }
    return e;
  }, $.apply(this, arguments);
}, I = n.forwardRef(function(e, a) {
  var r;
  te(re);
  var t = n.useRef(null), i = n.useRef(null), c = ue(i, e.dir);
  n.useImperativeHandle(t, function() {
    return {
      element: i.current,
      props: e
    };
  }), n.useImperativeHandle(a, function() {
    return t.current;
  });
  var o = n.useContext(ce), v = o[0], s = o[1], S = n.useContext(de), E = S[0], f = S[1], T = n.useContext(oe), R = T[1], _ = n.useMemo(function() {
    return e.selected || (Array.isArray(v) ? v.some(function(u) {
      return u === e.value;
    }) : v === e.value);
  }, [e.selected, e.value, v]), b = n.useMemo(function() {
    return E === e.value;
  }, [e.value, E]);
  n.useEffect(function() {
    b && i.current && i.current.focus();
  }, [b]);
  var O = n.useCallback(function(u) {
    s({ type: y.toggle, payload: e.value, event: u });
  }, [s, e.value]), k = n.useCallback(function(u) {
    e.removable && (R({ type: x.remove, payload: e.value, event: u }), f({ type: m.reset, payload: e.value, event: u }), s({ type: y.remove, payload: e.value, event: u }), e.onRemove && e.onRemove.call(void 0, {
      target: t.current,
      syntheticEvent: u
    }));
  }, [e.onRemove, e.value, e.removable, R, f, s]), C = n.useCallback(function(u) {
    switch (u.keyCode) {
      case z.left:
        f({ type: m.prev, payload: e.value, event: u });
        break;
      case z.right:
        f({ type: m.next, payload: e.value, event: u });
        break;
      case z.enter:
        s({ type: y.toggle, payload: e.value, event: u });
        break;
      case z.delete:
        k(u);
        break;
    }
    e.onKeyDown && e.onKeyDown.call(void 0, {
      target: t.current,
      syntheticEvent: u
    });
  }, [e.onKeyDown, e.value, f, s, k]), M = n.useCallback(function(u) {
    f({ payload: e.value, type: m.current, event: u }), e.onFocus && e.onFocus.call(void 0, {
      target: t.current,
      syntheticEvent: u
    });
  }, [e.onFocus, e.value, f]), A = n.useCallback(function(u) {
    e.onBlur && e.onBlur.call(void 0, {
      target: t.current,
      syntheticEvent: u
    });
  }, [e.onBlur]), N = le(e, t, { onClick: O });
  return n.createElement(
    "div",
    $({}, N, { role: e.role, id: e.value, style: e.style, ref: i, dir: c, tabIndex: ie(e.tabIndex, e.disabled, void 0), className: H("k-chip", (r = {
      "k-rtl": c === "rtl",
      "k-disabled": e.disabled,
      "k-selected": _,
      "k-focus": b
    }, r["k-chip-".concat(X.sizeMap[e.size] || e.size)] = e.size, r["k-rounded-".concat(X.roundedMap[e.rounded] || e.rounded)] = e.rounded, r["k-chip-".concat(e.fillMode)] = e.fillMode, r["k-chip-".concat(e.fillMode, "-").concat(e.themeColor)] = !!(e.fillMode && e.themeColor), r), e.className), "aria-checked": _, "aria-disabled": e.disabled, "aria-describedby": e.ariaDescribedBy, onFocus: M, onBlur: A, onKeyDown: C }),
    _ && (e.selectedIcon || e.selectedSvgIcon) && n.createElement(j, { className: "k-chip-icon", name: e.selectedIcon ? V(e.selectedIcon) : void 0, icon: e.selectedSvgIcon, size: "small" }),
    (e.icon || e.svgIcon) && n.createElement(j, { className: "k-chip-icon", name: e.icon ? V(e.icon) : void 0, icon: e.svgIcon, size: "small" }),
    e.avatar && n.createElement(
      "div",
      { className: "k-chip-avatar k-avatar k-rounded-".concat(e.avatar.rounded, " k-avatar-md k-avatar-solid k-avatar-solid-primary"), style: e.avatar.style },
      n.createElement(
        "span",
        { className: "k-avatar-image" },
        n.createElement("img", { src: e.avatar.image, alt: e.avatar.imageAlt })
      )
    ),
    n.createElement("span", { className: "k-chip-content" }, e.children !== void 0 ? e.children : e.text && n.createElement("span", { "aria-label": e.ariaLabel || e.text, className: "k-chip-label" }, e.text)),
    e.removable && n.createElement(
      "span",
      { className: "k-chip-actions" },
      n.createElement(
        "span",
        { className: H("k-chip-action", "k-chip-remove-action"), onClick: k },
        n.createElement(j, { name: e.removeIcon ? V(e.removeIcon) : void 0, icon: e.removeSvgIcon, size: "small" })
      )
    )
  );
}), ze = {
  id: l.string,
  text: l.string,
  value: l.any,
  dir: l.oneOf(["ltr", "rtl"]),
  removable: l.bool,
  removeIcon: l.string,
  removeIconSvg: G,
  disabled: l.bool,
  icon: l.string,
  svgIcon: G,
  selectedIcon: l.string,
  selectedIconSvg: G,
  onRemove: l.func,
  dataItem: l.any,
  selected: l.bool,
  ariaDescribedBy: l.string,
  size: l.oneOf([null, "small", "medium", "large"]),
  rounded: l.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: l.oneOf([null, "outline", "solid"]),
  // eslint-disable-next-line max-len
  themeColor: l.oneOf([null, "base", "info", "success", "warning", "error"])
}, Le = {
  disabled: !1,
  removable: !1,
  removeIcon: "k-i-x-circle",
  dir: "ltr",
  size: "medium",
  rounded: "medium",
  fillMode: "solid",
  themeColor: "base"
};
I.displayName = "KendoReactChip";
I.propTypes = ze;
I.defaultProps = Le;
export {
  I as C
};
